"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpProfileConfig = void 0;
const gs = require("@ivanlog/gs");
const App_1 = require("../App");
const tmpls_1 = require("./tmpls");
class CmpProfileConfig extends tmpls_1.CmpProfileConfigBase {
    constructor() {
        super();
    }
    loadAsync() {
        if (!App_1.App.Inst.auth.user)
            return;
        const user = App_1.App.Inst.auth.user;
        this.ctrls.lName.text = user.name;
        if (user.birthDay)
            this.ctrls.iBirthDate.value = gs.date.getDate(user.birthDay);
        if (user.created)
            this.ctrls.lRegDate.text = gs.date.getDate(user.created);
        this.ctrls.iPhone.value = App_1.App.Inst.auth.phone;
        this.ctrls.iEmail.value = App_1.App.Inst.auth.email;
        this.ctrls.iName.value = user.name;
    }
}
exports.CmpProfileConfig = CmpProfileConfig;
//# sourceMappingURL=CmpProfileConfig.js.map